import { z } from 'zod';

export const UserInformation = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  role: z.union([z.literal('admin'), z.literal('member')]),
});

export type UserInformation = z.infer<typeof UserInformation>;

export const GetUsersResponse = z.array(UserInformation);

export type GetUsersResponse = z.infer<typeof GetUsersResponse>;

export const SetUserRoleRequest = z.object({
  userId: z.number(),
  role: z.union([z.literal('admin'), z.literal('member')]),
});

export type SetUserRoleRequest = z.infer<typeof SetUserRoleRequest>;

export const SetUserRoleResponse = z.object({
  success: z.boolean(),
});

export type SetUserRoleResponse = z.infer<typeof SetUserRoleResponse>;
